<mat-form-field>
  <mat-label>Type</mat-label>
  <mat-select (selectionChange)="onTileSetTypeChange($event)" required [(value)]="value">
    @for (tileSetType of tileSet?.tileSetTypes ?? []; track tileSetType) {
      <mat-option [value]="tileSetType">
        {{ getTileType(tileSetType.tile.typeId) }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
